module.exports = __webpack_public_path__ + "img/cooling-unit-near-plants.9b726140.jpg";